import {createReducer, on} from '@ngrx/store';
import {HttpActionState} from 'app/main/pages/users/userslisting/store/users-listing.reducers';
import {ITablePagerOptions} from 'app/main/shared/shared/table/components/table-pager/ITablePagerOptions';
import * as ContentLibraryAction from './content-library-store.action';
import {Daum} from './content-library-store.dto';

export interface ContentLibraryState {
    contents: Daum[],
    allContents : Daum[],
    content:Daum,
    fetchContentLibraryRequestState: HttpActionState,
    addContentLibraryRequsetState: HttpActionState,
    updateContentLibraryRequsetState: HttpActionState,
    search: string,
    paging?: ITablePagerOptions;
}

const initialState: ContentLibraryState = {
    contents: [],
    allContents :[],
    content: {} as Daum,
    fetchContentLibraryRequestState: HttpActionState.Init,
    addContentLibraryRequsetState: HttpActionState.Init,
    updateContentLibraryRequsetState: HttpActionState.Init,
    search: '',
    paging: {
        pageSize: 1,
        currentPage: 1,
        pagesCount: 1,
        total: 0
    },
};

export const contentlibraryReducer = createReducer(initialState,
    on(ContentLibraryAction.fetchContentLibrary, (state) => ({
        ...state,
        fetchContentLibraryRequestState: HttpActionState.Busy
    })),
    on(ContentLibraryAction.clearState, () => ({
        ...initialState
    })),
    on(ContentLibraryAction.fetchContentLibrarySuccess, (state, { contentLiraries }) => ({
        ...state,
        paging: {
            currentPage: contentLiraries.current_page || 1,
            pagesCount: contentLiraries.last_page || 1,
            pageSize: contentLiraries.per_page || 1,
            total: contentLiraries.total || 0
        },
        contents: contentLiraries.data,
        fetchContentLibraryRequestState: HttpActionState.Done
    })),
    on(ContentLibraryAction.fetchAllContentLibrary, (state) => ({
        ...state,
        fetchContentLibraryRequestState: HttpActionState.Busy
    })),
    on(ContentLibraryAction.fetchAllContentLibrarySuccess, (state, { contentLiraries }) => ({
        ...state,
        allContents: contentLiraries,
        fetchContentLibraryRequestState: HttpActionState.Done
    })),
    on(ContentLibraryAction.fetchContentLibraryFailure, (state) => ({
        ...state,
        paging: initialState.paging,
        fetchContentLibraryRequestState: HttpActionState.Failed
    })),

    on(ContentLibraryAction.searchChange, (state, { searchValue }) => ({
        ...state,
        search: searchValue
    })),

    on(ContentLibraryAction.changePage, (state, { pageNumber }) => ({
        ...state,
        paging: {
            ...state.paging,
            currentPage: pageNumber
        }
    })),

    on(ContentLibraryAction.addContentLibrary, (state) => ({
        ...state,
        addContentLibraryRequsetState: HttpActionState.Busy
    })),
    on(ContentLibraryAction.addContentLibrarySuccess, (state, { response }) => ({
        ...state,
        contents: [...state.contents, response],
        allContents: [...state.contents, response],
        content: response,
        addContentLibraryRequsetState: HttpActionState.Done
    })),
    on(ContentLibraryAction.addContentLibraryFailure, (state) => ({
        ...state,
        addContentLibraryRequsetState: HttpActionState.Failed
    })),

    on(ContentLibraryAction.updateContentLibrary, (state) => ({
        ...state,
        updateContentLibraryRequsetState: HttpActionState.Busy
    })),
    on(ContentLibraryAction.updateContentLibrarySuccess, (state, { response }) => ({
        ...state,
        contents: updateContentLibrary(state.contents, response),
        allContents: updateContentLibrary(state.allContents, response),
        updateContentLibraryRequsetState: HttpActionState.Done
    })),
    on(ContentLibraryAction.updateContentLibraryFailure, (state) => ({
        ...state,
        updateContentLibraryRequsetState: HttpActionState.Failed
    })),

    on(ContentLibraryAction.deleteContent, (state) => ({
        ...state,
        deleteContentLibraryRequsetState: HttpActionState.Busy
    })),
    on(ContentLibraryAction.deleteContentLibrarySuccess, (state, { id }) => ({
        ...state,
        contents: state.contents.filter((content) => content.id != id),
        allContents: state.allContents.filter((content) => content.id != id),
        deleteContentLibraryRequsetState: HttpActionState.Done
    })),
    on(ContentLibraryAction.deleteContentLibraryFailure, (state) => ({
        ...state,
        deleteContentLibraryRequsetState: HttpActionState.Failed
    }))
);

function updateContentLibrary(state, specificContent) {
    const updatedContents = state.map(content => specificContent.id === content.id ? specificContent : content);
    return updatedContents;
}
